import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type MenuHeaderProps = {
  onClose: React.MouseEventHandler<HTMLElement>;
};

function MenuHeader({ onClose }: MenuHeaderProps) {
  return (
    <div className={`flex flex-row justify-between items-center p-3 mb-2`}>
      <h2>Menü</h2>
      <button onClick={onClose} className="p-1">
        <FontAwesomeIcon icon={faXmark} size="xl" />
      </button>
    </div>
  );
}

export default MenuHeader;
